import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule, InputMaskModule } from 'primeng/primeng';

import { SispacSharedModule } from '../shared/sispac-shared.module';

import { Ng2BRPipesModule } from 'ng2-brpipes';
import { CurrencyMaskModule } from 'ng2-currency-mask';

import { LaboratorioRouting } from './laboratorio.routing';

import { LaboratorioService } from './laboratorio.service';
import { UnidadeService } from '../shared/services/unidade.service';

import { GerenciarLaboratorioComponent } from './gerenciar-laboratorio/gerenciar-laboratorio.component';
import { CadastroLaboratorioFormComponent } from './cadastro-laboratorio-form/cadastro-laboratorio-form.component';
import { VisualizarLaboratorioComponent } from './visualizar-laboratorio/visualizar-laboratorio.component';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule, ReactiveFormsModule,

        LaboratorioRouting,

        ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule, InputMaskModule,

        Ng2BRPipesModule,
        CurrencyMaskModule,

        SispacSharedModule
    ],
    providers: [ LaboratorioService, UnidadeService ],
    declarations: [ GerenciarLaboratorioComponent, CadastroLaboratorioFormComponent, VisualizarLaboratorioComponent ]
})
export class LaboratorioModule { }



// WEBPACK FOOTER //
// ./src/app/components/laboratorio/laboratorio.module.ts